import React from "react";
import './Info_Card.css'

const Info_Card = ({ data }) => {
  return (
    <div className="Info_Card">

      <div 
        className="points_div"
        dangerouslySetInnerHTML={{ __html: data }}
      ></div>
    </div>
  );
};

export default Info_Card;




// import React from "react";
// import './Info_Card.css'

// const Info_Card = ({title,data}) => {
//   return (
//     <div className="Info_Card">
//       <p className="card_heading">
//         {title}
//       </p>

//       <div className="points_div">
//         {data?.map((item) => {
//           return (
//             <div className="point_row">
//               <img
//                 src="/assets/images/spandan/sacred_pulse/point.png"
//                 className="point_img"
//               />
//               <p className="point_text" dangerouslySetInnerHTML={{ __html: item }}></p>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default Info_Card;
